<template>
  <div class="bubble">
    <div class="bubble-finance">Finance</div>
    <div class="bubble-culture">Culture</div>
    <div class="bubble-internet">Internet</div>
    <div class="bubble-arrow">
      <span class="bubble-arrow-rect"></span>
      <span class="bubble-arrow-angle"></span>
    </div>
    <div class="bubble-acorange">ACOrange</div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.bubble {
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
  color: #fefefe;
  &-finance {
    display: inline-block;
    width: 106px;
    height: 106px;
    border-radius: 106px;
    line-height: 106px;
    text-align: center;
    background-color: #ffae00;
  }
  &-culture {
    display: inline-block;
    width: 106px;
    height: 106px;
    border-radius: 106px;
    line-height: 106px;
    text-align: center;
    background-color: #ff9000;
    margin-left: -14px;
  }
  &-internet {
    display: inline-block;
    width: 106px;
    height: 106px;
    border-radius: 106px;
    line-height: 106px;
    text-align: center;
    background-color: #ff7e00;
    margin-left: -14px;
  }
  &-arrow {
    display: inline-block;
    margin-left: 20px;
    &-rect {
      width: 31px;
      height: 10px;
      display: inline-block;
      background-color: #ff6c00;
      vertical-align: middle;
    }
    &-angle {
      border-width: 11px 22px;
      border-style: solid;
      display: inline-block;
      border-color: #ff6c00;
      border-color: transparent transparent transparent #ff6c00;
      vertical-align: middle;
    }
  }
  &-acorange {
    width: 116px;
    height: 116px;
    display: inline-block;
    background-color: #ec6900;
    line-height: 116px;
    text-align: center;
    border-radius: 116px;
    margin-left: -2px;
  }
}
</style>